<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/OVyKzC/tc-custom/9781614230007.jpg?1736951419280" alt="This image is the cover for the book Marshall Field's, Landmarks"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Marshall Field's, Landmarks
      </h1>
      <p class="bookDescription body article font2">
        <p><b>A history of the iconic department store and a city’s life over a century and a half.</b></p><p>Anyone who has waited in a Christmas line for the Walnut Room’s Great Tree can attest that Chicago’s loyalty to Marshall Field’s is fierce. Dayton-Hudson even had to take out advertising around town to apologize for changing the Field's hallowed green bags. And with good reason—the store and those who ran it shaped the city's streets, subsidized its culture, and heralded its progress.</p> The resulting commercial empire dictated wholesale trade terms in Calcutta and sponsored towns in North Carolina, but its essence was always Chicago. So when the Marshall Field name was retired in 2006 after the stores were purchased by Macy’s, protest slogans like “Field’s is Chicago” and “Field’s: as Chicago as it gets” weren't just emotional hype. Many still hope that name will be resurrected like the city it helped support during the Great Fire and the Great Depression. Until then, fans of Marshall Field’s can celebrate its history with this warm look back at the beloved institution.&lt;/
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Gayle Soucek
      </h2>
      
      <p class="authorDescription body article">Gayle Soucek is an author and freelance editor with several books and numerous magazine articles to her credit.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The History Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1fcfaa12